import { Card, IncidentHistory, IncidentRecord, PageHeader, Stack, useI18n } from '@daghfal/core';
import { Link, useParams } from 'react-router-dom';

/**
 * The child's incidents inside the guardian's history window, the latest first (FR-CHD-14). An incident's
 * notification opens its record directly.
 */
export function Incidents({ childId }: { childId: number }) {
  const { t } = useI18n();

  return (
    <Stack>
      <PageHeader title={t('incidents.title')} />
      <Card>
        <IncidentHistory childId={childId} link={(incident) => `/child/${childId}/incidents/${incident.id}`} />
      </Card>
    </Stack>
  );
}

/** One incident, read and acknowledged here (FR-CHD-12). */
export function Incident({ childId }: { childId: number }) {
  const { t } = useI18n();
  const { incidentId } = useParams();

  return (
    <Stack>
      <Link className="dg-button dg-button--ghost" to={`/child/${childId}/incidents`}>{t('action.back')}</Link>
      <IncidentRecord incidentId={Number(incidentId)} as="guardian" />
    </Stack>
  );
}
